// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__aoaih","options":"AnswerScale_options__3a_xX","selected":"AnswerScale_selected__28X8K"};